import React, { useState } from 'react'
import i18n from 'live/services/i18n';
import LiveSelect from 'live/components/forms/ui/select';
import { useEffect } from 'react';
import { getExtensionsQualifier } from './api/google-integration';

const ConfigForm = ({ config = {}, onChange }: any) => {    
    const [extensionsQualifiers, setExtensionsQualifiers] = useState();
    
    const [selectedExtensionsQualifiers, setSelectedExtensionsQualifiers] = useState(config.extensionQualifier);

    useEffect(() => {
      getExtensionsQualifier().then(response => {        
          setExtensionsQualifiers(response.map(ele => ({ value: ele, label: ele })));
      });
    }, [])

    return (
       <>
          <div>
                <label>{i18n('Integração Google Maps')}</label>
                <LiveSelect
                    placeholder="Choose the integration"
                    options={extensionsQualifiers}
                    value={selectedExtensionsQualifiers}
                    onChange={(value, obj) => {
                        onChange('extensionQualifier', value)
                        setSelectedExtensionsQualifiers(obj);
                    }}
                />
          </div>

          <div>
              <label>{i18n('Lookup Parameters')}</label>
              <input type="text" value={config.lookupParameters} onChange={({ target }) => {
                onChange('lookupParameters', target.value)
              }}/>

          </div>

          <div>
              <label>{i18n('Steps')}</label>
              <input type="number" min={1} max={10} value={config.steps} onChange={({ target }) => {

                if(+target.value > 0 && +target.value < 11){
                  onChange('steps', target.value)
                }
                else{
                  target.value = ''
                }
              }}/>

          </div>

          <div>
              <label>Zoom</label>
              <input type="number" min={1} max={25} value={config.zoom} onChange={({ target }) => {
                    onChange('zoom', target.value)
              }}/>
          </div>


       </>
    );
}

export default ConfigForm;
